// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from '../../../constants/Colors'

export default makeStyles(theme => ({
  button: {},
  icon: {},
  measure: {},
  measureValueContainer: {
    backgroundColor: Colors.BACKGROUND_COLOR_LIGHT,
    borderRadius: '50%',
    color: Colors.PRIMARY_FONT_COLOR,
    display: 'grid',
    fontSize: 12,
    gridAutoFlow: 'row',
    gridAutoRows: 'min-content',
    gridRowGap: 4,
    justifyItems: 'center',
    lineHeight: 'normal',
    padding: '12px 0px 10px 0px',
    width: 80,
  },
  root: {
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: 'min-content min-content min-content',
    gridColumnGap: 15,
  },
  value: {
    fontFamily: 'Poppins Bold',
    fontSize: 24,
    fontWeight: 'bold',
  },
}))
